import React from 'react';

const PlayIcon = () => (
    <svg width="145" height="145" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <polygon id="leftbar" fill="#fff" points="42 33 72 53 72 92 42 112" />
            <polygon id="rightbar" fill="#fff" points="72 53 93 67 102 73 93 79 72 92" />
            <circle stroke="#fff" strokeWidth="9" cx="72.5" cy="72.5" r="68" />
        </g>
    </svg>
);

export default PlayIcon;


// WEBPACK FOOTER //
// ./src/components/AudioPlayer/play-icon.js